// Components/Layout.js
import React from "react";
import Navbar from './Components/Navbar/Navbar.js' // Adjust the path as needed
import Footer from './Components/Footer/Footer.js'; // Adjust the path as needed

const Layout = ({ children }) => {
  return (
    <div>
      {/* <Navbar /> */}
      <main>{children}</main>
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;
